const PAGE_BOTTOM_OFFSET = 30;

export function checkIfScrolledToBottom(callback) {
    const scrollTop = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
    );

    if (
        window.innerHeight + scrollTop >
        document.documentElement.offsetHeight - PAGE_BOTTOM_OFFSET
    ) {
        callback();
    }
}
